import { handleActions } from "redux-actions";
import { set, setNewRideId } from "../actions/currentRide";

const defaultState = {
  ride: undefined,
  lastRideId: undefined,
};

export const selector = ({ currentRide }) => (currentRide);

const currentRideReducer = handleActions(
  {
    [set]: (state, { payload }) => ({
      ...state,
      ride: payload.ride,
    }),
    [setNewRideId]: (state, { payload }) => ({
      ...state,
      lastRideId: payload.rideId,
    }),
  },
  defaultState,
);

export default currentRideReducer;
